document.addEventListener('click', async function (e) {
    const btn = e.target.closest('#btnModalEliminarTipoReferencia');
    if (!btn) return;

    const id            = btn.getAttribute("data-id");
    const formEliminar  = document.querySelector("#formEliminarTipoReferencia");
    const modalEliminar = document.querySelector("#ModalEliminarTipoReferencia");

    if (!id || !formEliminar || !modalEliminar) {
        if (typeof lanzarAlerta === 'function') lanzarAlerta("Faltan parámetros para eliminar el tipo de referencia.", "alerta-roja");
        return;
    }

    try {
        const response = await fetch(`/api/configuracion/tipo-referencia/infoTipoReferencia?idTipoReferencia=${id}`, {
            method: "GET",
            credentials: "include",
            headers: { "Content-Type": "application/json" }
        });

        if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

        const result = await response.json();
        const data   = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') lanzarAlerta("No se encontró información del tipo de referencia.", "alerta-roja");
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        modalEliminar.classList.add('modal--show');

        const inputId      = formEliminar.querySelector('#idTipoReferenciaEliminar');
        const strongNombre = modalEliminar.querySelector('#nombreEliminarTipoReferencia');

        if (inputId)      inputId.value          = data.idTipoReferencia    || "";
        if (strongNombre) strongNombre.textContent = data.tipoReferencia || "";

    } catch (error) {
        console.error("Error al obtener información del tipo de referencia:", error);
        if (typeof lanzarAlerta === "function") lanzarAlerta("No se pudo cargar la información del tipo de referencia.", "alerta-roja");
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id !== 'formEliminarTipoReferencia') return;
    e.preventDefault();

    const formulario    = e.target;
    const modalEliminar = document.querySelector("#ModalEliminarTipoReferencia");
    const btnSubmit     = formulario.querySelector('#btnEliminarTipoReferencia');
    const spinner       = formulario.querySelector('#spinner');
    const formData      = new FormData(formulario);

    if (!modalEliminar || !btnSubmit || !spinner) {
        if (typeof lanzarAlerta === 'function') lanzarAlerta("Faltan parámetros para eliminar el tipo de referencia.", "alerta-roja");
        return;
    }

    btnSubmit.disabled = true;
    spinner.style.display = 'inline-block';

    try {
        const respuesta = await fetch('/api/configuracion/tipo-referencia/eliminar', { method: 'POST', body: formData });
        const json      = await respuesta.json();
        const status    = respuesta.status;
        const resultado = json.result;

        if (status !== 200) {
            alert("Error crítico al procesar la solicitud.");
            setTimeout(() => { window.location.reload(); }, 1000);
            return;
        }

        if (resultado.hayErrores) {
            resultado.errores.forEach(error => { lanzarAlerta(error.mensaje, error.clase); });
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
            modalEliminar.classList.remove('modal--show');
        } else {
            lanzarAlerta("Tipo de referencia eliminado correctamente.", "alerta-verde");
            setTimeout(() => { window.location.reload(); }, 800);
        }

    } catch (error) {
        console.error("Error:", error);
        modalEliminar.classList.remove('modal--show');
        btnSubmit.disabled = false;
        spinner.style.display = 'none';
    }
});
